/**
 * Receive view: the address with its public key and derivation path, and a copy button.
 */

import ko from 'knockout';
import { ModelBase } from './base';
import type { WalletModel } from './wallet';

export class ReceiveModel extends ModelBase {
    readonly copyStatus = ko.observable('');
    private copyTimer = 0;

    constructor(private readonly wallet: WalletModel) {
        super();
    }

    async copy(): Promise<void> {
        try {
            await navigator.clipboard.writeText(this.wallet.address());
            this.copyStatus('Copied');
        } catch {
            this.copyStatus('Copying is not allowed here: select the address and copy it');
        }
        clearTimeout(this.copyTimer);
        this.copyTimer = window.setTimeout(() => this.copyStatus(''), 3000);
    }
}
